import { ApexOptions } from 'apexcharts';
import { useEffect, useMemo, useState } from 'react';

import { generateChartDataUri } from '../../../../../components/graphs';
import { END_POINTS } from '../../../../../services';
import { getUniqueId } from '../../../../../utils/commonUtils';
import { toFixedDigit } from '../../../../../utils/number';
import { Shift } from '../../../contexts/ShiftProvider.types';
import useGraphApiData from '../../../useGraphApiData';
import PdfPtsCoveredGraph from './PdfPtsCoveredGraph';
import useTableData from './useTableData';
import useWeekWiseSummary from './useWeekWiseSummary';

const chartId = getUniqueId();

export const usePdfPtsCoveredGraph = ({
  scenario,
  day,
  shifts,
}: {
  scenario: string;
  day: string | number;
  shifts?: Shift[];
}) => {
  const [graphUri, setGraphUri] = useState('');
  const { isLoading: isPtsDataLoading, data: apiResponse } = useGraphApiData(
    END_POINTS.DASHBOARD.getPtsArrivalsPtsCovered(scenario)
  );

  const isLoadingGraphs = isPtsDataLoading;
  const graphData = { data: apiResponse || [], shift: shifts || [] };

  const {
    seriesData,
    graphOptions,
    rows: tableRows,
    columns: tableColumns,
    grpModel: tableGroupModel,
  } = useTableData(graphData || {}, String(day), chartId);
  const { columns: summaryTablecols, rows: summaryTableRows } =
    useWeekWiseSummary(graphData);
  let ptsCoveredGraphOptions: ApexOptions = useMemo(
    () => ({
      ...graphOptions,
      chart: {
        ...(graphOptions?.chart || {}),
        height: 600,
        id: chartId,
        toolbar: {
          show: false,
        },
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          dataLabels: {
            position: 'bottom',
          },
        },
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [0, 1],
        style: {
          colors: ['#000'],
        },
        formatter: function (val, opt) {
          return toFixedDigit(Array.isArray(val) ? val[0] : val);
        },
      },
    }),
    [graphOptions]
  );

  useEffect(() => {
    const generateGraphUri = async () => {
      const res: any = await generateChartDataUri({
        ...ptsCoveredGraphOptions,
        series: [...seriesData],
      });
      setGraphUri(res?.['imgURI'] || '');
    };
    generateGraphUri();
  }, [ptsCoveredGraphOptions, seriesData]);

  return {
    // renderer: PdfPtsCoveredGraph({
    //   graphUri,
    //   tableGroupModel,
    //   tableColumns,
    //   tableRows,
    //   summaryTablecols,
    //   summaryTableRows,
    // }),
    renderer: (
      <PdfPtsCoveredGraph
        graphUri={graphUri}
        tableGroupModel={tableGroupModel}
        tableColumns={tableColumns}
        tableRows={tableRows}
        summaryTablecols={summaryTablecols}
        summaryTableRows={summaryTableRows}
      />
    ),
    isLoading: isLoadingGraphs,
  };
};
export default usePdfPtsCoveredGraph;
